import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Clients';

export const clientEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  basePath: () => BASE_PATH,
} as const;

export default clientEndpoints;
